export default "__VITE_ASSET__Su4mjRrb__"